const mergeObject = require('hobbit-base/modules/plugins/mergeObject');
const { ROUTE_REQUIRE_ENUM } = require('hobbit-base/components/bizs/main/constant');
const engineBaseConfig = require('hobbit-engine-base/modules/config');
const appName = require('../package.json').name;

const ROUTE_PREFIX = '/([a-z]{2}-[a-z]{2})?/website';

const { MUST_LOGIN, HAS_CHILD, SELF_CHILD } = ROUTE_REQUIRE_ENUM;

module.exports = mergeObject(engineBaseConfig, {
  runtime: process.env.VUE_APP_RUNTIME,
  site: {
    publicPath: `https://s.vipkidstatic.com/fe-static/${appName}/prod/${process.env.VUE_APP_DRONE || 'default'}/`,
    noLangPath: true,
  },
  log: {
    appName,
  },
  routes: {
    // #region brand
    home: {
      index: 1,
      path: '/([a-z]{2}-[a-z]{2})?/',
      view: '/brand/home/home.vue',
      mview: '/brand/home/m_home.vue',
      preloads: ['signin', 'signup'],
      revertLangOption: {
        'ar-ae': 'en-us',
      },
    },
    howItWorks: {
      index: 2,
      path: `${ROUTE_PREFIX}/brand/how-it-works/`,
      view: '/brand/howitworks/howitworks.vue',
      mview: '/brand/howitworks/m_howitworks.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
    },
    ourTeachers: {
      index: 3,
      path: `${ROUTE_PREFIX}/brand/our-teachers/`,
      view: '/brand/ourteachers/ourteachers.vue',
      mview: '/brand/ourteachers/m_ourteachers.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
    },
    // 老师详情
    teacherdetail: {
      index: 4,
      path: `${ROUTE_PREFIX}/brand/teacherdetail/`,
      view: '/brand/teacherdetail/teacherdetail.vue',
      mview: '/brand/teacherdetail/m_teacherdetail.vue',
      meta: {
        agentAuth: ['*'],
      },
    },
    // #endregion
    // #region acounnt
    signup: {
      index: 1010,
      path: `${ROUTE_PREFIX}/account/signup/`,
      view: '/account/signup/signup.vue',
      preloads: ['signin'],
      meta: {
        agentAuth: ['*'],
      },
    },
    openSignup: {
      index: 1010,
      path: `${ROUTE_PREFIX}/account/opensignup/`,
      view: '/account/openSignup/openSignup.vue',
    },
    signin: {
      index: 1020,
      path: `${ROUTE_PREFIX}/account/signin/`,
      view: '/account/signin/signin.vue',
      preloads: ['signup'],
      meta: {
        agentAuth: ['*'],
      },
    },
    oauth: {
      index: 1021,
      path: `${ROUTE_PREFIX}/account/oauth/`,
      view: '/account/oauth/oauth.vue',
      meta: {
        agentAuth: ['*'],
      },
    },
    childcreation: {
      index: 1025,
      path: `${ROUTE_PREFIX}/account/childcreation/`,
      view: '/account/childcreation/childcreation.vue',
      meta: {
        require: MUST_LOGIN,
        agentAuth: ['*'],
      },
    },
    entryassessment: {
      index: 1026,
      path: `${ROUTE_PREFIX}/account/entryassessment/`,
      view: '/account/entryassessment/entryassessment.vue',
      meta: {
        require: HAS_CHILD,
      },
    },
    trialbooking: {
      index: 1027,
      path: `${ROUTE_PREFIX}/account/trialbooking/`,
      view: '/account/trialbooking/trialbooking.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    onboardconfirmed: {
      index: 1028,
      path: `${ROUTE_PREFIX}/account/onboardconfirmed/`,
      view: '/account/onboardconfirmed/onboardconfirmed.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    thanksPage: {
      index: 1030,
      path: `${ROUTE_PREFIX}/account/thankspage/`,
      view: '/account/thanksPage/thanksPage.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    childExtraInfo: {
      index: 600,
      path: `${ROUTE_PREFIX}/account/childExtraInfo/`,
      view: '/account/childExtraInfo/childExtraInfo.vue',
      meta: {
        require: SELF_CHILD,
        agentAuth: ['*'],
      },
    },
    userinfo: {
      index: 20,
      path: `${ROUTE_PREFIX}/account/userinfo/`,
      view: '/account/userinfo/userinfo.vue',
      mview: '/account/userinfo/m_userinfo.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    myaddress: {
      index: 20,
      path: `${ROUTE_PREFIX}/account/myaddress/`,
      view: '/account/myAddress/myAddress.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    editaddress: {
      index: 20,
      path: `${ROUTE_PREFIX}/account/editaddress/`,
      view: '/account/editAddress/editAddress.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    resetpassword: {
      index: 20,
      path: `${ROUTE_PREFIX}/account/resetpassword/`,
      view: '/account/resetpassword/resetpassword.vue',
    },
    deleteAccount: {
      index: 21,
      path: `${ROUTE_PREFIX}/account/deleteAccount/`,
      view: '/account/deleteAccount/index.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    // #endregion
    // #region goods
    goodsList: {
      index: 745,
      path: `${ROUTE_PREFIX}/goods/goodslist/`,
      view: '/goods/goodsList/goodsList.vue',
      mview: '/goods/goodsList/m_goodsList.vue',
    },
    goodsDetail: {
      index: 746,
      path: `${ROUTE_PREFIX}/goods/goodsdetail/`,
      view: '/goods/goodsDetail/goodsDetail.vue',
    },
    couponBox: {
      index: 747,
      path: `${ROUTE_PREFIX}/goods/couponbox/`,
      view: '/goods/couponBox/couponBox.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    // #endregion
    // #region promotion
    landingpage: {
      index: 667,
      path: `${ROUTE_PREFIX}/promotion/landingpage/`,
      view: '/promotion/landingpage/landingpage.vue',
      mview: '/promotion/landingpage/landingpage.vue',
      // revertLangOption: {
      // 'ar-ae': 'en-us',
      // },
    },
    referral: {
      index: 668,
      path: `${ROUTE_PREFIX}/promotion/referral/`,
      view: '/promotion/referral/referral.vue',
      mview: '/promotion/referral/m-referral.vue',
    },
    learningreport: {
      index: 669,
      path: `${ROUTE_PREFIX}/promotion/learningreport/`,
      view: '/promotion/learningreport/learningreport.vue',
    },
    learningBrief: {
      index: 669,
      path: `${ROUTE_PREFIX}/promotion/learningbrief/`,
      view: '/promotion/learningBrief/learningBrief.vue',
    },
    aiActivityHome: {
      index: 669,
      path: `${ROUTE_PREFIX}/promotion/aiActivity/home`,
      mview: '/promotion/aiActivity/home/m-home.vue',
      view: '/promotion/aiActivity/home/m-home.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
    },
    aiActivityPaySuccess: {
      index: 669,
      path: `${ROUTE_PREFIX}/promotion/aiActivity/aiActivityPaySuccess`,
      mview: '/promotion/aiActivity/aiActivityPaySuccess/m-aiActivityPaySuccess.vue',
      view: '/promotion/aiActivity/aiActivityPaySuccess/m-aiActivityPaySuccess.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
    },
    invitefriends: {
      index: 660,
      path: `${ROUTE_PREFIX}/promotion/invitefriends/`,
      view: '/promotion/referralposter/invitefriends/invitefriends.vue',
      meta: {
        require: MUST_LOGIN,
      },
      revertLangOption: {
        // 'ar-ae': 'en-us',
      },
    },
    experienceCourse: {
      index: 670,
      path: `${ROUTE_PREFIX}/promotion/experienceCourse/home`,
      mview: '/promotion/experienceCourse/home/m-home.vue',
      view: '/promotion/experienceCourse/home/m-home.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
    },
    experienceCourseResults: {
      index: 670,
      path: `${ROUTE_PREFIX}/promotion/experienceCourse/results`,
      mview: '/promotion/experienceCourse/results/m-results.vue',
      view: '/promotion/experienceCourse/results/m-results.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
    },
    // app假约课
    reservationTime: {
      index: 670,
      path: `${ROUTE_PREFIX}/promotion/fakeAppointmentBooking/reservationTime`,
      mview: '/promotion/fakeAppointmentBooking/reservationTime/reservationTime.vue',
      view: '/promotion/fakeAppointmentBooking/reservationTime/reservationTime.vue',
    },
    // app假约课结果
    reservationResult: {
      index: 670,
      path: `${ROUTE_PREFIX}/promotion/fakeAppointmentBooking/reservationResult`,
      mview: '/promotion/fakeAppointmentBooking/reservationResult/reservationResult.vue',
      view: '/promotion/fakeAppointmentBooking/reservationResult/reservationResult.vue',
    },
    // 添加切页微信
    enterpriseWeChat: {
      index: 670,
      path: `${ROUTE_PREFIX}/promotion/fakeAppointmentBooking/enterpriseWeChat`,
      mview: '/promotion/fakeAppointmentBooking/enterpriseWeChat/enterpriseWeChat.vue',
      view: '/promotion/fakeAppointmentBooking/enterpriseWeChat/enterpriseWeChat.vue',
      meta: {
        login: false,
      },
    },
    tiktokVerification: {
      index: 670,
      path: `${ROUTE_PREFIX}/promotion/tiktok/tiktokverification/`,
      view: '/promotion/tiktok/tiktokverification/tiktokverification.vue',
    },
    tiktokOrderInfo: {
      index: 672,
      path: `${ROUTE_PREFIX}/promotion/tiktok/tiktokorderinfo/`,
      view: '/promotion/tiktok/tiktokorderinfo/tiktokorderinfo.vue',
      meta: {
        login: true,
      },
    },
    programposter: {
      index: 661,
      path: `${ROUTE_PREFIX}/promotion/programposter/`,
      view: '/promotion/referralposter/programposter/programposter.vue',
      revertLangOption: {
        // 'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    makeposter: {
      index: 668,
      path: `${ROUTE_PREFIX}/promotion/makeposter/`,
      view: '/promotion/referralposter/makeposter/newposter.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    shareposter: {
      index: 668,
      path: `${ROUTE_PREFIX}/promotion/shareposter/`,
      view: '/promotion/referralposter/makeposter/shareposter.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    createposter: {
      index: 668,
      path: `${ROUTE_PREFIX}/promotion/createposter/`,
      view: '/promotion/referralposter/makeposter/createposter.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    uploadposter: {
      index: 668,
      path: `${ROUTE_PREFIX}/promotion/uploadposter/`,
      view: '/promotion/referralposter/uploadposter/uploadposter.vue',
      revertLangOption: {
        // 'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    friendCardHome: {
      index: 670,
      path: `${ROUTE_PREFIX}/promotion/friendcardhome/`,
      view: '/promotion/friendCardHome/friendCardHome.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    lpChildcreation: {
      index: 690,
      path: `${ROUTE_PREFIX}/promotion/lpchildcreation/`,
      view: '/promotion/lpchildcreation/lpchildcreation.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    lpChildLevelController: {
      index: 691,
      path: `${ROUTE_PREFIX}/promotion/lpchildlevelcontroller/`,
      view: '/promotion/lpchildlevelcontroller/lpchildlevelcontroller.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    lpTrialBooking: {
      index: 692,
      path: `${ROUTE_PREFIX}/promotion/lptrialbooking/`,
      view: '/promotion/lptrialbooking/lptrialbooking.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    lpCollectStudentInfo: {
      index: 693,
      path: `${ROUTE_PREFIX}/promotion/lpcollectstudentinfo/`,
      view: '/promotion/lpcollectstudentinfo/lpcollectstudentinfo.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    lpBookingSuccess: {
      index: 694,
      path: `${ROUTE_PREFIX}/promotion/lpbookingsuccess/`,
      view: '/promotion/lpbookingsuccess/lpbookingsuccess.vue',
      meta: {
        // require: MUST_LOGIN,
      },
    },
    lpTrialBookingForB: {
      index: 692,
      path: `${ROUTE_PREFIX}/promotion/lptrialbookingforb/`,
      mview: '/promotion/lptrialbookingForB/lptrialbookingForB.vue',
      view: '/promotion/lptrialbookingForB/lptrialbookingForB.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },

    lpChildStage: {
      index: 689,
      path: `${ROUTE_PREFIX}/promotion/lpchildstage/`,
      view: '/promotion/lpformfirstflow/lpchildstage/lpchildstage.vue',
      pv: 'front_lp_stage',
    },
    lpChildGrade: {
      index: 690,
      path: `${ROUTE_PREFIX}/promotion/lpchildgrade/`,
      view: '/promotion/lpformfirstflow/lpchildgrade/lpchildgrade.vue',
      pv: 'front_lp_grade',
    },
    lpChildSchool: {
      index: 691,
      path: `${ROUTE_PREFIX}/promotion/lpchildschool/`,
      view: '/promotion/lpformfirstflow/lpchildschool/lpchildschool.vue',
      pv: 'front_lp_school',
    },
    lpFormFirst: {
      index: 692,
      path: `${ROUTE_PREFIX}/promotion/lpformfirst/`,
      view: '/promotion/lpformfirstflow/lpformfirst/lpformfirst.vue',
      pv: 'front_lp_phone',
    },
    lpFormFirstBooking: {
      index: 693,
      path: `${ROUTE_PREFIX}/promotion/lpformfirstbooking/`,
      view: '/promotion/lpformfirstflow/lpformfirstbooking/lpformfirstbooking.vue',
      pv: 'front_lp_book',
    },
    // #endregion
    // #region order
    orderList: {
      index: 800,
      path: `${ROUTE_PREFIX}/order/orderlist/`,
      view: '/order/orderList/orderList.vue',
      mview: '/order/orderList/m_orderList.vue',
      keepAlive: true,
      meta: {
        require: SELF_CHILD,
      },
    },
    orderDetail: {
      index: 810,
      path: `${ROUTE_PREFIX}/order/orderdetail/`,
      view: '/order/orderDetail/orderDetail.vue',
      mview: '/order/orderDetail/m_orderDetail.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    physicalOrderList: {
      index: 801,
      path: `${ROUTE_PREFIX}/order/physicalorderlist/`,
      view: '/order/physicalOrderList/physicalOrderList.vue',
      mview: '/order/physicalOrderList/m_physicalOrderList.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    bill: {
      index: 811,
      path: `${ROUTE_PREFIX}/order/bill/`,
      view: '/order/bill/bill.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    orderCheckout: {
      index: 801,
      path: `${ROUTE_PREFIX}/order/ordercheckout/`,
      view: '/order/orderCheckout/orderCheckout.vue',
      mview: '/order/orderCheckout/m_orderCheckout.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    application: {
      index: 802,
      path: `${ROUTE_PREFIX}/order/application/`,
      view: '/order/application/application.vue',
      mview: '/order/application/application.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
    },
    // #endregion
    // #region payment
    pay: {
      index: 803,
      path: `${ROUTE_PREFIX}/payment/pay/`,
      view: '/payment/pay/pay.vue',
      mview: '/payment/pay/m_pay.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    notificationDetail: {
      index: 900,
      path: `${ROUTE_PREFIX}/account/notificationdetail/`,
      view: '/account/notificationDetail/notificationDetail.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
    },
    payResult: {
      index: 80,
      path: `${ROUTE_PREFIX}/payment/result/`,
      view: '/payment/result/result.vue',
      mview: '/payment/result/m_result.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    // #endregion
    // #region service
    downloads: {
      index: 25,
      path: `${ROUTE_PREFIX}/service/downloads/`,
      view: '/service/downloads/downloads.vue',
      mview: '/service/downloads/m_downloads.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
    },
    applink: {
      index: 26,
      path: `${ROUTE_PREFIX}/service/applink/`,
      view: '/service/applink/applink.vue',
    },
    approute: {
      index: 27,
      path: `${ROUTE_PREFIX}/service/approute/`,
      view: '/service/approute/approute.vue',
      mview: '/service/approute/m_approute.vue',
    },
    content: {
      index: 80,
      path: `${ROUTE_PREFIX}/service/content/`,
      view: '/service/content/content.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
    },
    error403: {
      index: 403,
      path: `${ROUTE_PREFIX}/service/error403/`,
      view: '/service/error403/error403.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        agentAuth: ['*'],
      },
    },
    error404: {
      index: 404,
      path: '*',
      view: '/service/error404/error404.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        agentAuth: ['*'],
      },
    },
    // #endregion
  },
  abtest: {},
  // 业务自定义配置信息
  custom: {
    // === 禁用IM的路由 ===
    disableIMRoutes: {
      pc: {
        deleteAccount: true,
        signup: true,
        signin: true,
        bill: true,
        orderList: true,
        orderDetail: true,
        physicalOrderList: true,
        orderCheckout: true,
        pay: true,
        landingpage: true,
        makeposter: true,
        uploadposter: true,
        invitefriends: true,
        programposter: true,
        childcreation: true,
        childExtraInfo: true,
        entryassessment: true,
        trialbooking: true,
        onboardconfirmed: true,
        oauth: true,
        newposter: true,
        createposter: true,
        shareposter: true,
        aiActivityHome: true,
        aiActivityPaySuccess: true,
        friendCardHome: true,
        tiktokVerification: true,
        tiktokOrderInfo: true,
        experienceCourse: true,
        enterpriseWeChat: true,
        reservationResult: true,
        reservationTime: true,
        lpChildcreation: true,
        lpChildLevelController: true,
        lpTrialBooking: true,
        lpCollectStudentInfo: true,
        lpBookingSuccess: true,
        lpTrialBookingForB: true,
        payResult: true,
        applink: true,
        lpChildAndLeveling: true,
        learningreport: true,
        learningBrief: true,
        lpChildStage: true,
        lpChildGrade: true,
        lpChildSchool: true,
        lpFormFirst: true,
        lpFormFirstBooking: true,
        approute: true,
      },
      m: {
        deleteAccount: true,
        signup: true,
        signin: true,
        bill: true,
        orderList: true,
        orderDetail: true,
        physicalOrderList: true,
        orderCheckout: true,
        pay: true,
        landingpage: true,
        makeposter: true,
        uploadposter: true,
        invitefriends: true,
        programposter: true,
        childcreation: true,
        childExtraInfo: true,
        entryassessment: true,
        trialbooking: true,
        onboardconfirmed: true,
        oauth: true,
        newposter: true,
        createposter: true,
        shareposter: true,
        aiActivityHome: true,
        aiActivityPaySuccess: true,
        friendCardHome: true,
        tiktokVerification: true,
        tiktokOrderInfo: true,
        experienceCourse: true,
        enterpriseWeChat: true,
        reservationResult: true,
        reservationTime: true,
        lpChildcreation: true,
        lpChildLevelController: true,
        lpTrialBooking: true,
        lpCollectStudentInfo: true,
        lpBookingSuccess: true,
        lpTrialBookingForB: true,
        payResult: true,
        applink: true,
        lpChildAndLeveling: true,
        learningreport: true,
        learningBrief: true,
        editaddress: true,
        myaddress: true,
        lpChildStage: true,
        lpChildGrade: true,
        lpChildSchool: true,
        lpFormFirst: true,
        lpFormFirstBooking: true,
        approute: true,
      },
    },
    // === 禁用系统弹窗的路由 ===
    disableSystemNoticeRoutes: {
      resetpassword: true,
      approute: true,
    },
    cmsApiBase: '/rest/gw/mgt/api/cms',
    subscriptionPackageTypeId: 4, // 订阅包类型ID
    subscriptionRenewalTypeId: 5, // 订阅子包类型ID
    minimumConsumptionTypeId: 18, // 固定课消类型ID
  },
});
